import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { isEmbedMode } from 'v2/shared/utils/embed-session'

// Embed stays on PubNub whatever the flag says: the playground-stream routes have
// no embed gateway rule, and the stream reads the AOM from localStorage, which the
// iframe never writes. Every fork reads this, never the raw flag, or embed skips
// the PubNub subscribe as well and receives nothing.
export const isStreamTransportActive = (flagEnabled: boolean, embed: boolean): boolean =>
  flagEnabled && !embed

export const usePlaygroundStreamTransport = (): boolean =>
  isStreamTransportActive(useFeatureFlags().playgroundStreamTransportEnabled, isEmbedMode())
